export default __webpack_public_path__ + "static/media/uni-swap.4accf705.svg";